import React from "react";
import { createApi } from "../../../utils/createApi";
import { AxiosError } from "axios";
import { handleButtonShading } from "./handleButtonShading";
import { NavigateFunction } from "react-router-dom";
import { universalAPIErrorHandler } from "../../../utils/universalAPIErrorHandler";

export const handleVerificationSelection = (
  inputString: string,
  selectedRow: any,
  clipsData: any,
  setClipsData: any,
  setSelectedRow: any,
  setPageLoading: any,
  setVerifiedClicked: any,
  setUnverifiedClicked: any,
  navigate: NavigateFunction
) => {
  const backupInvestigationData = clipsData;

  const updatedInvestigationData = clipsData;
  updatedInvestigationData.forEach((object: any, index: number) => {
    if (selectedRow.file_id === object.file_id) {
      updatedInvestigationData[index].ground_truth = inputString;
    }
  });
  setClipsData(updatedInvestigationData);

  const postedOutcome = {
    username: selectedRow.username,
    file_id: selectedRow.file_id,
    ground_truth: inputString,
  };

  const AxiosUI = createApi("");

  const retryFunction = () => {
    handleVerificationSelection(
      inputString,
      selectedRow,
      clipsData,
      setClipsData,
      setSelectedRow,
      setPageLoading,
      setVerifiedClicked,
      setUnverifiedClicked,
      navigate
    );
  };

  AxiosUI.post(`/clip/ground_truth/`, postedOutcome).then(
    () => {
      setSelectedRow((previousState: any) => {
        return { ...previousState, ground_truth: inputString };
      });
      localStorage.setItem("clipsSelectedRow", JSON.stringify(selectedRow));
      setPageLoading(false);
    },
    (reason: AxiosError) => {
      universalAPIErrorHandler(reason, navigate, retryFunction, () => {
        setClipsData(backupInvestigationData);
        localStorage.setItem(
          "clipsData",
          JSON.stringify(backupInvestigationData)
        );
        handleButtonShading(
          selectedRow,
          setVerifiedClicked,
          setUnverifiedClicked
        );
        setPageLoading(false);
        alert("Error submitting verificaiton status, please try again");
      });
    }
  );
};
